"use strict";

import React, {useContext, useEffect} from 'react';
import NavList from "../../account/component/NavList";
import MainNavListItemContent from "../../account/component/MainNavListItemContent";
import { Route, Switch} from "react-router-dom";
import AccountContext from "../context/AccountContext";
import AccountEchecks from "./AccountEchecks";
import AccountEchecksCreatePreScreen from "./AccountEchecksCreatePreScreen";
import AccountSettings from "./AccountSettings";
import AccountSettingAddresses from "./AccountSettingAddresses";
import AccountSettingCredentials from "./AccountSettingCredentials";
import AccountEcheckCreateAlternativeProvider from "../provider/AccountEcheckCreateAlternativeProvider";
import {useAlert} from "react-alert";
import {useHistory} from "react-router-dom";

const Account = (props) => {
    const {
        id=0,
        isFetchingAccount=false,
        account={},
        address={},
        fetchAccount=()=>{},
        updateAccountAddress=()=>{},
    } = useContext(AccountContext);

    const attention = `${address.f_name || ''} ${address.l_name || ''}`;
    const companyName = address?.company_name || '';
    const emailAddress = account?.user?.email || '';
    const alert = useAlert();
    const history = useHistory();

    useEffect(()=>{
        fetchAccount();
    }, []);

    function handleUpdateAddress(id=0, data={}){
        updateAccountAddress(id, data);
    }

    return (
        <React.Fragment>
            <div className="account__container">
                <div className="account__main-navigation__column">
                    <div className="account__main-navigation">
                        <div className="account__main-navigation__header" style={{minHeight: '2rem', position: 'relative',}}>
                            {isFetchingAccount &&
                                <div className="loading loading--cover loading--center-flex loading--w-flip" />
                            }
                            {!!companyName &&
                              <h3 className="account__main-navigation__header__headline">{companyName}</h3>
                            }
                            {!!attention &&
                              <h5 className="account__main-navigation__header__subhead"
                                  style={{marginBottom: !!emailAddress ? '.5rem' : 0 }}>{attention}</h5>
                            }
                            {!!emailAddress &&
                              <small className="account__main-navigation__header__text"
                                 style={{color: '#666666', marginBottom: 0,}}>{emailAddress}</small>
                            }
                        </div>
                        <nav className="account__main-navigation__nav">
                            <NavList className="account__main-navigation__nav" navList={[
                                {pathName: '/echeck/accounts/echecks', title: 'Manage E-checks',
                                    content: <MainNavListItemContent content="E-Checks" description="manage e-checks"/>,},
                                {pathName: '/echeck/accounts/settings', title: 'Settings',
                                    content: <MainNavListItemContent content="Settings" description="password, email, etc."/>,},
                            ]}/>
                        </nav>
                    </div>
                </div>
                <div className="account__main-content__column">
                    <Switch>
                        <Route exact path='/echeck/accounts/echecks' component={ AccountEchecks } />
                        <Route path='/echeck/accounts/echecks/create' render={
                            (props)=>
                                <AccountEcheckCreateAlternativeProvider >
                                    <AccountEchecksCreatePreScreen isFetchingAccount={isFetchingAccount} email={emailAddress} userAddress={address} />
                                </AccountEcheckCreateAlternativeProvider>
                        } />
                        <Route exact path='/echeck/accounts/settings' render={
                            (props)=>
                                <AccountSettings account={account} address={address} />
                        } />
                        <Route path='/echeck/accounts/settings/addresses' render={
                            (props)=>
                                <AccountSettingAddresses
                                    account={account}
                                    address={address}
                                    onUpdateAddress={handleUpdateAddress} />
                        } />
                        <Route exact path='/echeck/accounts/settings/credentials'
                               component={ AccountSettingCredentials } />
                    </Switch>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Account;
